import { useAvailabilityTypes } from '@/services/availability/useAvailabilityTypes';
import { FC, useState } from 'react';
import strings from '../team.translations';
import { getTeamCalendarLeaveTypeTextClass } from './teamCalendarLeaveTypeStyles';
import { FaAsterisk } from 'react-icons/fa';

const COLLAPSED_LIMIT = 8;
const SHOW_ALL_KEY = 'teamCalendarKey_showAll';

export const TeamCalendarLeaveTypeKey: FC = () => {
  const leaveTypes = useAvailabilityTypes(true).filter(type => type.leaveTypeId);

  const [showAll, setShowAll] = useState<boolean>(() => {
    return localStorage.getItem(SHOW_ALL_KEY) === 'true';
  });

  const toggleShowAll = () => {
    setShowAll(prev => {
      const next = !prev;
      localStorage.setItem(SHOW_ALL_KEY, String(next));
      return next;
    });
  };

  const totalItems = leaveTypes.length;
  const needsToggle = totalItems > COLLAPSED_LIMIT;
  const visibleTypes = needsToggle && !showAll ? leaveTypes.slice(0, COLLAPSED_LIMIT) : leaveTypes;

  const staticTags = (
    <>
      <span className="whitespace-nowrap inline-flex items-center rounded-sm bg-primary-500 px-4 py-2 font-semibold text-white border">
        {strings.teamCalendar.onShift}
      </span>
      <div className="whitespace-nowrap inline-flex items-center rounded-sm bg-gray-100 px-4 py-2 font-semibold text-gray-400 border space-x-2">
        <FaAsterisk className="h-3 w-3" />
        <span>{strings.teamCalendar.availabilityChanged}</span>
      </div>
    </>
  );

  return (
    <div className="border-t bg-white">
      <div className="flex items-center gap-2 text-sm py-2 pr-3 pl-8 lg:pl-28">
        <span className="font-semibold text-secondary-std">{strings.teamCalendar.key}</span>
        <div className="flex flex-wrap items-center gap-2 flex-1">
          {staticTags}
          {visibleTypes.map(type => (
            <span
              key={type.leaveTypeId}
              className={`whitespace-nowrap inline-flex items-center rounded-sm px-4 py-2 font-semibold border ${getTeamCalendarLeaveTypeTextClass(type)}`}
              style={{ backgroundColor: type.color }}
            >
              {type.name}
            </span>
          ))}
        </div>
        {needsToggle && (
          <button
            onClick={toggleShowAll}
            className="whitespace-nowrap inline-flex items-center rounded-sm px-4 py-2 font-semibold border border-gray-400 text-gray-600 hover:bg-gray-50 ml-auto shrink-0"
          >
            {showAll ? strings.teamCalendar.hide : strings.teamCalendar.showAll}
          </button>
        )}
      </div>
    </div>
  );
};
